import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";

const InvIcon = (props) => <ReceiptLongIcon {...props} />;

export default InvIcon;
